import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Flex, IconButton, Badge } from "@radix-ui/themes";
import { ChevronLeftIcon, GearIcon } from "@radix-ui/react-icons";
import styles from "../AutomationConfiguration.module.scss";
import { SimulatorChannel } from "@/api/simulator/simulator.model";

export function AutomationConfigurationHeader({
  channel,
  label,
  icon,
}: {
  channel: SimulatorChannel;
  label?: string;
  icon?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const { simulatorId } = useParams();

  const handleBack = useCallback(() => {
    if (channel === "copilot" || channel === "knowledge_hub") {
      navigate(`/automation-center/training`);
    } else {
      navigate(`/automation/${simulatorId}`);
    }
  }, [navigate, simulatorId, channel]);

  return (
    <Flex
      flexShrink={"0"}
      py={"8px"}
      px={"12px"}
      gap={"2"}
      className={styles.Header}
    >
      <IconButton
        color="gray"
        variant="soft"
        highContrast
        size="1"
        onClick={handleBack}
      >
        <ChevronLeftIcon />
      </IconButton>

      <Badge color={"gray"} size={"2"} highContrast>
        {icon ?? <GearIcon />}
        {label ?? "Configurations"}
      </Badge>
    </Flex>
  );
}
